import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class AtualizacaoService extends BaseService {
  constructor() {
    super(`${ConfigApi.atualizacaoURL}`);
  }

  getFilter() {
    return new Filter();
  }

  // upload do ZIP do pacote junto com os metadados (multipart)
  async insert(body) {
    delete body.id;

    const data = new FormData();
    Object.keys(body).forEach(k => {
      data.append(k, body[k]);
    });

    this.setLoading(true);
    try {
      const response = await this.api.post(this.url, data);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }
}

class Filter {
  constructor() {
    this.versao = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new AtualizacaoService();
